import React from 'react'

const FilterPetsContext = React.createContext({})

export const FilterPetsProvider = FilterPetsContext.Provider

export default FilterPetsContext
